document.addEventListener("DOMContentLoaded", () => {
  if (typeof AOS === "undefined") {
    console.error("AOS not found — make sure you added it in theme.liquid");
    return;
  }

  const defaultAnim = "fade-up"; // your preferred animation

  // Select all theme section divs
  const sections = document.querySelectorAll('[id^="shopify-section-"]');

  // Skip the first 1–2 sections (like header + hero)
  sections.forEach((section, index) => {
    if (index > 1 && !section.hasAttribute("data-aos")) {
      section.setAttribute("data-aos", defaultAnim);
    }
  });

  // Initialize after attributes are set
  AOS.init({
    duration: 800,
    once: true,
  });
});
